exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".automationMetricPage_dropdowns__Fcer2{display:flex;justify-content:space-evenly}[dir] .automationMetricPage_dropdowns__Fcer2{border-style:solid #fcf9f9;padding-top:2rem;padding-bottom:4rem;margin:2rem}[dir] .automationMetricPage_buttonContainer__nZNSD{margin-top:2.1rem}", ""]);

// Exports
exports.locals = {
	"dropdowns": "automationMetricPage_dropdowns__Fcer2",
	"buttonContainer": "automationMetricPage_buttonContainer__nZNSD"
};